import Router from 'vue-router'
import store from '@/store/index.js'
import routes from '@/routes'

function createRouter(){
  const router = new Router({
    routes: routes,
    //スクロール位置を指定
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        //savePotisionがあるとvueデフォルトのスクロール挙動になるようです。（スクロール位置がページ遷移後も保存される）
        return savedPosition
      } else if (to.hash) {
        //router-linkで＃（id）指定リンクした場合
        return {
          selector: to.hash,
          offset: { x :0, y:200 }
        }
      } else {
        //savedPositionがなく、かつ、router-linkで＃を使用していない場合、スクロール位置はtopになります。
        return { x: 0, y: 0 }
      }
    }
  })
  
  /**
   * Vue Router の ルートメタフィールド を使って遷移可能か判断
   * @see https://router.vuejs.org/ja/guide/advanced/meta.html
   */
  // eslint-disable-next-line no-unused-vars
  router.beforeEach(async (to, from, next) => {
    store.dispatch('error/clearError')
    if (!store.getters['mode/getConfirmed'] && to.path !== '/'){
      next('/')
      scroll(0, 0)
    } else if (to.meta.mode === undefined){
      //ページがない場合エラー
      next('/404')
      scroll(0, 0)
    } else if (to.meta.mode === 'all'){
      //選択画面か許諾の画面の場合、モードがなんであろうと入力内容をリセットし、簡易・詳細・気候風土・特定事業主基準いずれにも行ける状態に書き換える
      store.dispatch('data/reset')
      store.dispatch('mode/setMode', null)
      next()
    } else if (store.getters['mode/getMode'] === null) {
      //簡易・詳細・気候風土・特定事業主基準いずれにも行ける状態の場合、遷移先のModeに書き換え、住宅タイプ(bsc_type)を設定してから遷移
      store.dispatch('mode/setMode', to.meta.mode)
      if(to.meta.mode == 'simple' || to.meta.mode == 'simple'){
        store.dispatch('data/update', {bsc_type:'1'})
      }else if(to.meta.mode == 'trad'){
        store.dispatch('data/update', {bsc_type:'2'})
      }else if(to.meta.mode == 'ees'){
        store.dispatch('data/update', {bsc_type:'3'})
      }
      next()
    } else if (store.getters['mode/getMode'] === to.meta.mode) {
      //同じ計算方式（簡易・詳細・気候風土・特定事業主基準）同士の移動の場合は移動を許可
      next()
    } else {
      //簡易から詳細、詳細から簡易など、別の計算方式への移動は事前に書き換えがなされていない限りエラー、前のページに強制遷移
      next('/400')
      scroll(0, 0)
    }
  })

  return router
}

export default createRouter